import React, { Component } from "react";
import moment from "moment";
import { getRequest, patchRequest } from "../../utils/httpRequest";
import Filters from "../AccountActivity/Filters";
import ActivityPagination from "../AccountActivity/ActivityPagination";
import Table from "./Table";
import { initialFiltersState } from "./helpers";
import { t } from "../../utils/i18n";

class UserActivities extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transfers: [],
      // Seed the currency filter from initialCurrency so the "History" buttons on
      // the wallet balances page open this list pre-filtered to that token.
      filters: { ...initialFiltersState, currency: props.initialCurrency || "" },
      loading: true,
      currentPage: 1,
    };
  }

  componentDidMount() {
    // When opened with a pre-selected currency (from a wallet "History" button),
    // load that filtered view straight away instead of the full unfiltered list.
    if (this.state.filters.currency) {
      this.getTransfers();
      return;
    }

    getRequest("/crypto_transfers.json").then((response) => {
      const sortedTransfers = response.transfers.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      this.setState({
        transfers: sortedTransfers,
        totalPages: response.total_pages,
        loading: false,
      });
    });
  }

  onSelectFilter = (key, value) => {
    const { filters } = this.state;

    const updatedFilters = { ...filters, [key]: value };

    this.setState({ filters: updatedFilters });
  };

  handlePageChange = (e, currentPage) => {
    e.preventDefault();
    this.setState({ currentPage }, () => this.getTransfers());
  };

  clearFilters = (e) => {
    e.preventDefault();

    this.setState({ filters: initialFiltersState }, () =>
      this.filterTransfers(e)
    );
  };

  filterTransfers = (e) => {
    e.preventDefault();

    this.setState({ loading: true, currentPage: 1 }, () => this.getTransfers());
  };

  getTransfers() {
    const {
      filters: { startDate, endDate, status, currency, transferType, search },
      currentPage,
    } = this.state;

    const url =
      `/crypto_transfers.json?q[created_at_gteq]=${startDate}&q[created_at_lteq]=${endDate}&q[external_status_cont]=${status}&` +
      `q[transfer_type]=${transferType}&q[search_term]=${search}&` +
      `q[source_currency_or_destination_currency_cont]=${currency}&page=${currentPage}`;

    getRequest(url).then((response) => {
      const sortedTransfers = response.transfers.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      this.setState({
        transfers: sortedTransfers,
        totalPages: response.total_pages,
        loading: false,
      });
    });
  }

  removeTransfer = (e, transferId) => {
    e.preventDefault();

    if (
      confirm(
        t("account.activities.remove_confirm")
      ) == true
    ) {
      const crsfToken = $('meta[name="csrf-token"]').attr("content");

      patchRequest(
        `/crypto_transfers/${transferId}/remove.json`,
        {},
        {
          "X-CSRF-Token": crsfToken,
        }
      ).then((response) => {
        const newTransfers = this.state.transfers.filter(
          (transfer) => transfer.id !== transferId
        );

        this.setState({
          transfers: newTransfers,
        });
      });
    }
  };

  render() {
    const { currencies, hideFilters, canViewCardTransactionDetails } =
      this.props;
    const { transfers, currentPage, totalPages, filters, loading } = this.state;

    return (
      <div className="account-activity pb-5">
        {!hideFilters && (
          <Filters
            currencies={currencies}
            filters={filters}
            filterTransfers={this.filterTransfers}
            onSelectFilter={this.onSelectFilter}
            clearFilters={this.clearFilters}
          />
        )}
        <Table
          transfers={transfers}
          canViewCardTransactionDetails={canViewCardTransactionDetails}
          removeTransfer={this.removeTransfer}
          loading={loading}
        />
        {totalPages > 1 && (
          <ActivityPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={this.handlePageChange}
          />
        )}
      </div>
    );
  }
}

export default UserActivities;
